module.exports = __webpack_public_path__ + "img/social-group_azul.4df04956.svg";